import React from 'react'

import IconBase, { IconProps } from './IconBase'

const IconEuroCircle = ({ size, className }: IconProps) => (
  <IconBase fillNone strokeCurrent strokeWidth={1.5} size={size} className={className}>
    <path d="M14.25 7.756a4.5 4.5 0 1 0 0 8.488M7.5 10.5h5.25m-5.25 3h5.25M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
  </IconBase>
)

export default IconEuroCircle
